;(function() {
  'use strict'

  userService.$inject = ["$q", "$state", "$rootScope", "glPrefs", "AUTH_EVENTS", "glDialog", "glAuthService", "resources", "usersResource"];
  angular.module('core.services').factory('userService', userService)

  /* @ngInject */
  function userService(
    $q,
    $state,
    $rootScope,
    glPrefs,
    AUTH_EVENTS,
    glDialog,
    glAuthService,
    resources,
    usersResource
  ) {
    var prefs = glPrefs.create('userService')
    var user = {}

    return {
      login: login,
      hasCredentials: hasCredentials,
      signup: signup,
      signupEmail: signupEmail,
      reset: reset,
      update: update,
      getLastEmail: getLastEmail,
      get: get,
      loggedIn: loggedIn,
      logout: logout,
      setUser: setUser,
      promptLogin: promptLogin,
      showLogin: showLogin,
      showSignup: showSignup,
      getUsernameChecker: getUsernameChecker,
      getEmailChecker: getEmailChecker,
      getRolesByEmail: getRolesByEmail,
      Roles: glAuthService.Roles,
      hasRole: hasRole,
    }

    function login(auth, silent) {
      return glAuthService.login(auth).then(function(userData) {
        setUser(userData)
        if (silent !== true) {
          $rootScope.$broadcast(AUTH_EVENTS.loginSuccess)
        }
        return user
      })
    }

    function hasCredentials() {
      return glAuthService.hasCredentials()
    }

    function signup(data) {
      return $q(function(resolve, reject) {
        usersResource
          .signup(data)
          .success(function(x, data) {
            login({ token: data.token }, true)
              .then(resolve)
              .catch(reject)
          })
          .error(function(resp, status) {
            if (status === 409) {
              reject('A user with this email already exists.')
            } else {
              reject('There was an issue signing you up, please try again.')
            }
          })
      })
    }

    function signupEmail(email, fullname) {
      return $q(function(resolve, reject) {
        var data = {
          email: email,
          fullname: fullname,
          legacy: true, // obfuscated attribute name for bypassing email validation
        }
        usersResource
          .createEmailUser(data)
          .success(function(resource, resp) {
            resolve(resp)
          })
          .error(function() {
            reject()
          })
      })
    }

    function reset(data) {
      return $q(function(resolve, reject) {
        data = angular.copy(data)
        delete data.password // hack, should be in client-lib
        setLastEmail(data.email)
        usersResource
          .passwordReset(data)
          .success(resolve)
          .error(reject)
      })
    }

    function update(data) {
      data = _.clone(data)
      return $q(function(resolve, reject) {
        usersResource
          .updateCustomer(data)
          .success(function() {
            setUser(data)
            resolve()
          })
          .error(reject)
      })
    }

    function setUser(userData) {
      angular.copy(userData, user)
      glPrefs.setUser(user && user.id)

      if (user && user.email) {
        setLastEmail(user.email)
      }
    }

    function getLastEmail() {
      prefs.get('lastEmail')
    }

    function setLastEmail(value) {
      prefs.set('lastEmail', value)
    }

    function get() {
      return user
    }

    function loggedIn() {
      return !!user.id
    }

    function logout() {
      return glAuthService.logout().then(function() {
        setUser(null)
        $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess)
      })
    }

    function promptLogin(message, event) {
      return glDialog.show({
        templateUrl: 'auth-dialog.template.html',
        controller: 'AuthDialogController',
        targetEvent: event,
        locals: {
          message: message,
        },
      })
    }

    function showLogin(event, locals) {
      locals = locals || {}
      locals.state = 'login'

      return glDialog.show({
        templateUrl: 'auth-dialog.template.html',
        controller: 'AuthDialogController',
        targetEvent: event,
        locals: locals,
      })
    }

    function showSignup(event, locals) {
      locals = locals || {}
      locals.state = 'signup'

      return glDialog.show({
        templateUrl: 'auth-dialog.template.html',
        controller: 'AuthDialogController',
        targetEvent: event,
        locals: locals,
      })
    }

    function getUsernameChecker() {
      var States = {
        IDLE: 'idle',
        CHECKING: 'checking',
        AVAILABLE: 'available',
        TAKEN: 'taken',
      }
      var performCheckDelayed = _.debounce(performCheck, 400)
      var obj = {
        check: check,
        state: States.IDLE,
        classNames: null,
        isChecking: isChecking,
        hasChecked: hasChecked,
      }
      return obj

      function check(username) {
        obj.state = States.CHECKING
        return performCheckDelayed(username)
      }

      function performCheck(username) {
        return $q(function(resolve, reject) {
          if (!username) {
            obj.state = States.IDLE
            reject()
            return
          }
          var user = get()
          var isSame =
            loggedIn() &&
            user.username &&
            user.username.toLowerCase() === username.toLowerCase()
          var isVariant = isSame && user.username !== username
          // console.log('isSame=', isSame, 'isVariant=', isVariant); // temp
          if (isVariant) {
            obj.state = States.AVAILABLE
            resolve()
            return
          }
          if (isSame) {
            obj.state = States.IDLE
            reject()
            return
          }
          usersResource
            .verifyUsername({ username: username })
            .success(function() {
              obj.state = States.TAKEN
              obj.classNames = 'gi gi-close'
              reject()
            })
            .error(function() {
              obj.state = States.AVAILABLE
              obj.classNames = 'gi gi-done'
              resolve()
            })
        })
      }

      function isChecking() {
        return obj.state === States.CHECKING
      }

      function hasChecked() {
        return obj.state === States.AVAILABLE || obj.state === States.TAKEN
      }
    }

    function getRolesByEmail(email) {
      return $q(function(resolve, reject) {
        usersResource
          .getRolesByEmail({ email: email })
          .success(function(x, response) {
            resolve(response.roles)
          })
          .error(function(data, status) {
            reject({
              data: data,
              status: status,
            })
          })
      })
    }

    function getEmailChecker() {
      var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      var States = {
        IDLE: 'idle',
        CHECKING: 'checking',
        AVAILABLE: 'available',
        // EMAILUSER: 'email-user',
        // PHONEUSER: 'phone-user',
        NOTAVAILABLE: 'notavailable',
      }
      // var performCheckDelayed = _.debounce(performCheck, 400);
      var obj = {
        check: check,
        state: States.IDLE,
        classNames: null,
        isChecking: isChecking,
        hasChecked: hasChecked,
      }
      return obj

      function check(email) {
        obj.state = States.CHECKING
        obj.isPhoneUser = null
        obj.isEmailUser = null
        // return performCheckDelayed(email);
        return performCheck(email)
      }

      function performCheck(email) {
        return $q(function(resolve, reject) {
          if (!email) {
            obj.state = States.IDLE
            reject()
            return
          }
          if (!emailRegex.test(email)) {
            obj.state = States.NOTAVAILABLE
            obj.classNames = 'gi gi-close'
            reject()
            return
          }
          usersResource
            .getRolesByEmail({ email: email })
            .success(function(resource, resp) {
              var hasEmailRole = _.includes(resp.roles, 'ROLE_EMAIL')
              if (hasEmailRole) {
                obj.state = States.AVAILABLE
                obj.isEmailUser = true
                obj.classNames = 'gi gi-done'
              } else {
                obj.state = States.NOTAVAILABLE
                obj.isPhoneUser = true
                obj.classNames = 'gi gi-close'
              }
              reject()
            })
            .error(function() {
              obj.state = States.AVAILABLE
              obj.classNames = 'gi gi-done'
              resolve()
            })
        })
      }

      function isChecking() {
        return obj.state === States.CHECKING
      }

      function hasChecked() {
        return (
          obj.state === States.AVAILABLE || obj.state === States.NOTAVAILABLE
        )
      }
    }

    function hasRole(role) {
      return user && _.includes(user.roles, role)
    }
  }
})()
